import { IconPlay } from '@components/ui/icon/play';
import { Text } from '@components/ui/typography';
import { spacingBottomM } from '@components/_blog-detail/spacings';
import { parse } from '@config/theme';
import { blurImage, urlFor } from '@lib/sanity/url-for';
import { cx } from '@linaria/core';
import Image from 'next/image';
import React, { FC, useRef, useState } from 'react';
import YouTube from 'react-youtube';
import { CbVideo as CbVideoModel } from '__generated__/sanity';
export const CbVideo: FC<CbVideoModel> = ({
  image,
  caption,
  width,
  background,
  youtubeVideoId
}) => {
  const player = useRef<any>();
  const [isPlaying, setIsPlaying] = useState(false);
  return <div className={cx(spacingBottomM, background === 'grey' && bgGrey)}>
      <figure data-width={width} className={figure}>
        <div className={ratio}>
          <Image className={img} src={urlFor(image).width(1000).toString()} blurDataURL={blurImage(image)} placeholder="blur" layout="fill" alt={image.alt} data-hidden={isPlaying ? '' : undefined} />
          <YouTube videoId={youtubeVideoId} onReady={handleReady} onEnd={() => setIsPlaying(false)} opts={{
          playerVars: {
            modestbranding: 1,
            rel: 0
          }
        }} />
          <button className={playButton} onClick={handlePlay} data-hidden={isPlaying ? '' : undefined}>
            <IconPlay />
          </button>
        </div>
        {caption && <Text variant="bodyRegular" color="shade500" mt="4" as="figcaption">
            {caption}
          </Text>}
      </figure>
    </div>;
  function handleReady(e) {
    player.current = e.target;
  }
  function handlePlay() {
    if (player.current) {
      setIsPlaying(true);
      player.current.playVideo();
    }
  }
};
const ratio = parse({
  position: 'relative',
  mx: 'auto'
}, "rvfr3uc");
const playButton = parse({
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}, "pmt36hn");
const figure = parse({
  mx: 'auto'
}, "f1rit8vi");
const bgGrey = parse({
  pt: '64',
  pb: '64',
  bg: 'shade300'
});
const img = parse({
  position: 'absolute',
  width: '100%',
  height: '100%'
}, "i1w9b79z");

require("./CbVideo.linaria.module.css!=!../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./CbVideo.tsx");